<form [formGroup]="form" (ngSubmit)="onSave()">
  <mat-dialog-content>
    <ng-content></ng-content>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="actions">
    <logpn-form-action-buttons
      (cancelEvent)="onCancel()"
      [cancelLabel]="cancelLabel"
      [saveLabel]="saveLabel">
    </logpn-form-action-buttons>
  </mat-dialog-actions>
</form>
